// extracted by mini-css-extract-plugin
export default {"mainHeader":"BloodPressure_mainHeader__e3yYD","b_bg":"BloodPressure_b_bg__EURab","b_header":"BloodPressure_b_header__Qt6TH","b_cont":"BloodPressure_b_cont__MThAh"};